export default __webpack_public_path__ + "static/media/element_67.3b974784.webp";